module.exports = __webpack_public_path__ + "static/media/85.5edd73ef.jpg";